import { combineReducers } from 'redux';

import loadStatus from './loadStateReducer';
import integrationScriptStep from './scriptStepReducer';
import endpoint from './endpointReducer';
import auth from './authReducer';
import runLocation from './runLocationReducer';
import viewState from './viewStateReducer';

export default combineReducers({
  integrationScriptStep,
  endpoint,
  loadStatus,
  auth,
  runLocation,
  viewState,
});
